import { render } from "./Courses.vue?vue&type=template&id=0f1b4c4e&scoped=true"
import script from "./Courses.vue?vue&type=script&lang=js"
export * from "./Courses.vue?vue&type=script&lang=js"

import "./Courses.vue?vue&type=style&index=0&id=0f1b4c4e&scoped=true&lang=css"
import "./Courses.vue?vue&type=style&index=1&id=0f1b4c4e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1b4c4e"]])

export default __exports__